import { Component, InputSignal, InputSignalWithTransform, OutputEmitterRef, booleanAttribute, input, output } from '@angular/core';
import { GeneralIconButtonComponent } from '../general-icon-button/general-icon-button.component';
import { MatIcon } from '@angular/material/icon';

export type TipType = 'warning' | 'error' | 'complete' | 'custom';

@Component({
  selector: 'app-tip',
  templateUrl: './tip.component.html',
  styleUrl: './tip.component.scss',
  host: {
    class: 'tip',
    '[attr.data-app-tip-type]': 'type()',
  },
  imports: [MatIcon, GeneralIconButtonComponent],
})
export class TipComponent {
  readonly type: InputSignal<TipType> = input.required<TipType>();

  readonly showCloseButton: InputSignalWithTransform<unknown, boolean> = input<unknown, boolean>(false, { transform: booleanAttribute });

  readonly closeEvent: OutputEmitterRef<void> = output<void>();

  closeTip(): void {
    this.closeEvent.emit();
  }
}
